<style scoped>
.notification-container {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 40vh;
}
.pull-right {
  float: right;
}
</style>

<template>
  <mu-menu :open.sync="open">
    <mu-button flat>
      <mu-badge color="transparent" v-if="uploadQueue.length">
        <mu-icon value="notifications"></mu-icon>
        <mu-circular-progress :size="12" :color="isPreview ? 'secondary' : 'primary'" slot="content"></mu-circular-progress>
      </mu-badge>
      <mu-badge :content="notificationCount.toString()" :color="isPreview ? 'secondary' : 'primary'" circle v-else>
        <mu-icon value="notifications"></mu-icon>
      </mu-badge>
    </mu-button>
    <div slot="content" ref="scroll" class="notification-container">
      <mu-list v-if="uploadQueue.length">
        <mu-sub-header>{{$t('notification.inProgress')}}</mu-sub-header>
        <UploadQueueItem v-for="(item, index) in uploadQueue" :upload="item" />
        <mu-divider />
      </mu-list>
      <mu-list v-if="exportQueue.length">
        <mu-sub-header>{{$t('notification.export.title')}}</mu-sub-header>
        <ExportQueueItem v-for="(item, index) in exportQueue" :exportItem="item" />
        <mu-divider />
      </mu-list> 
      <div class="full-width">
        <mu-button small flat @click="onMarkAllAsRead" color="primary" v-if="items.length !== 0 && hasUnread">
          {{$t('notification.markAllAsRead')}}
        </mu-button>
        <mu-button small flat @click="onDeleteAllRead" color="primary" class="pull-right" v-if="items.length !== 0 && hasRead">
          {{$t('notification.deleteAllRead')}}
        </mu-button>
      </div>
      <mu-list textline="two-line">
        <mu-sub-header>{{$t('notification.title')}}</mu-sub-header>
        <mu-list-item v-for="(item, index) in items">
          <mu-list-item-action button v-if="isCsvType(item.type)">
            <mu-button icon @click="onDownloadFile(item)">
              <mu-icon value="get_app" :color="item.read ? 'default' : 'primary'"></mu-icon>
            </mu-button>
          </mu-list-item-action>
          <mu-list-item-action button v-if="isUploadType(item.type) || isCommentType(item.type)">
            <mu-button icon @click="onToMedia(item)">
              <mu-icon value="input" :color="item.read ? 'default' : 'primary'"></mu-icon>
            </mu-button>
          </mu-list-item-action>
          <mu-list-item-content>
            <mu-list-item-title>
              <component :is="item.read ? 'span' : 'b'">
                <span v-if="item.reference.hasOwnProperty('timestamp') && item.reference.timestamp > 0">
                  {{$t('notification.message.' + item.type + 'WithTime', {
                  object: item.reference && item.reference.object ? item.reference.object : '',
                  subject: item.reference && item.reference.subject ? item.reference.subject : '',
                  content: item.reference && item.reference.content ? item.reference.content : '',
                  time: item.reference && item.reference.timestamp ? timeFormatter(item.reference.timestamp) : ''
                  })}} 
                </span>
                <span v-else>
                  {{$t('notification.message.' + item.type, {
                  object: item.reference && item.reference.object ? item.reference.object : '',
                  subject: item.reference && item.reference.subject ? item.reference.subject : '',
                  content: item.reference && item.reference.content ? item.reference.content : ''
                  })}} 
                </span>
              </component>
            </mu-list-item-title>
            <mu-list-item-sub-title>
              <component :is="item.read ? 'span' : 'b'">
                {{stringTime(item.created_at)}}
              </component>
            </mu-list-item-sub-title>
          </mu-list-item-content>
          <mu-list-item-action v-if="!item.read">
            <mu-button icon @click="onMarkAsRead(item)">
              <mu-icon value="done" :color="item.read ? 'default' : 'primary'"></mu-icon>
            </mu-button>
          </mu-list-item-action>
          <mu-list-item-action v-else>
            <mu-button icon @click="onClickDelete(item)">
              <mu-icon value="delete"></mu-icon>
            </mu-button>
          </mu-list-item-action>
        </mu-list-item>
        </transition-group>
        <mu-list-item v-if="items.length === 0">
          <mu-list-item-title>
            {{$t('notification.empty')}}
          </mu-list-item-title>
        </mu-list-item>
      </mu-list>
    </div>
  </mu-menu>
</template>

<script>

// Components
import UploadQueueItem from '@/components/Notification/UploadQueueItem.vue'
import ExportQueueItem from '@/components/Notification/ExportQueueItem.vue'

import timeFormatter from '@/utils/timeFormatter.js'

// Library
import axios from "axios";

export default {
  name: 'NotificationPanel',
  components: {
    UploadQueueItem,
    ExportQueueItem
  },
  props: {

  },
  data() {
    return {
      items: [],
      last: 5,
      scrolled: false,
      open: false,
      interval: null,
    }
  },
  computed: {
    authorized() {
      return this.$store.state.auth.authorized;
    },
    isPreview() {
      if(this.$store.getters.previewMode) {
        return true;
      } else {
        return false;
      }
    },
    notificationCount() {
      if(typeof this.items === 'undefined') {
        return 0;
      } else {
        return this.items.filter(x => !(x.hasOwnProperty('read') && x.read)).length;
      }
    },
    scroll() {
      return this.$refs.scroll;
    },
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },
    triggerNotification() {
      return this.$store.getters.triggerNotification;
    },
    uploadQueue() {
      return this.$store.getters.uploadQueue;
    },
    uploadQueueLength() {
      return this.uploadQueue.length;
    },
    exportQueue() {
      return this.$store.getters.exportQueue;
    },
    exportQueueLength() {
      return this.exportQueue.length;
    },
    hasUnread() {
      if(this.items.length) {
        var result = false;
        this.items.forEach(item => {
          if(item.hasOwnProperty('read') && !item.read) {
            result = true;
          }
        });
        return result;
      } else {
        return false;
      }
    },
    hasRead() {
      if(this.items.length) {
        var result = false;
        this.items.forEach(item => {
          if(item.hasOwnProperty('read') && item.read) {
            result = true;
          }
        });
        return result;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.getData();
    this.interval = setInterval(this.getData, 60000);
    this.scroll.addEventListener("scroll", this.handleScroll);
  },
  watch: {
    authorized(newValue) { // Watch on authorized
      if(newValue) {
        this.getData()
      }
    },
    triggerRefresh() {
      this.getData()
    },
    triggerNotification(newValue) {
      this.open = true;
    },
    uploadQueueLength() {
      this.$store.commit('triggerRefresh');
    },
    exportQueueLength() {
      this.$store.commit('triggerRefresh');
    },
    notificationCount() {
      this.$store.commit('triggerRefresh');
    },
  },
  methods: {
    getData() {
      axios.get(this.$store.getters.urlApi + "notification?last=" + this.last, {
        headers: {
          token: this.$store.state.auth.token
        }
      })
      .then(res => {
        this.items = [];
        res.data.data.notifications.forEach((item, index) => {
          this.items[index] = item;
        })
      });
    },
    handleScroll() {
      this.scrolled = Math.ceil(this.scroll.scrollTop) >= this.scroll.scrollHeight - this.scroll.offsetHeight;
      if (this.scrolled) {
        this.last += 5;
        this.getData();
      }
    },

    onDownloadFile(item) {
      axios({
        method: 'get',
        url: this.$store.getters.urlApi + 'file?path=csv/' + item.reference.uid + '.csv',
          headers: {
            token: this.$store.state.auth.token
          },
          responseType: 'arraybuffer'
      }).then(res => {
        let blob = new Blob([res.data], { type: 'text/csv' });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = item.reference.object + '_' + item.type + '_' + new Date().getTime() + '.csv';
        link.click();
      })
      .catch(err => {
        console.log(err.message)
      });
    },
    onMarkAsRead(item) {
      axios.put(this.$store.getters.urlApi + "notification/" + item._id, {
        read: true
      }, {
        headers: {
          token: this.$store.state.auth.token
        },
        }
      ).then(() => {
        this.getData();
      });
    },
    onMarkAllAsRead() {
      axios.put(this.$store.getters.urlApi + "notification", {
        read: true
      }, {
        headers: {
          token: this.$store.state.auth.token
        },
        }
      ).then(() => {
        this.getData();
      });
    },

    onToMedia(item) {
      if(item.reference.hasOwnProperty('timestamp') && item.reference.timestamp > 0) {
        this.$router.push({
          name: 'MediaStartFrom',
          params: {
            mediaId: item.reference.uid,
            startFrom: item.reference.timestamp
          }
        });
      } else {
        this.$router.push({
          name: 'Media',
          params: {
            mediaId: item.reference.uid
          }
        });
      }
    },
    onClickDelete(item) {
      axios.delete(this.$store.getters.urlApi + "notification/" + item._id, {
        headers: {
          token: this.$store.state.auth.token
        },
        }
      ).then(() => {
        this.getData();
      });
    },
    onDeleteAllRead() {
      axios.delete(this.$store.getters.urlApi + "notification", {
        headers: {
          token: this.$store.state.auth.token
        },
        }
      ).then(() => {
        this.getData();
      });
    },

    isCsvType(type) {
      if(type === 'comments' || type === 'completion' || type === 'quiz' || type === 'videoAction') {
        return true;
      } else {
        return false;
      }
    },
    isUploadType(type) {
      if(type === 'upload') {
        return true;
      } else {
        return false;
      }
    },
    isCommentType(type) {
      if(type === 'comment' || type === 'question' || type === 'reply' || type === 'annotation') {
        return true;
      } else {
        return false;
      }
    },

    stringTime(time) {
      var d = new Date(time);
      const myTimeZone = 8;
      d.setTime( d.getTime() + myTimeZone * 60 * 60 * 1000 );
      var delta = Math.round((+new Date - d) / 1000);
      var minute = 60,
        hour = minute * 60,
        day = hour * 24,
        week = day * 7,
        month = day * 30,
        year = day * 356;
      var str = "";
      if (delta < 30) {
        str += this.$t('time.justNow');
      } else if (delta < minute) {
        str += delta + this.$t('time.secondsAgo');
      } else if (delta < 2 * minute) {
        str += this.$t('time.minuteAgo');
      } else if (delta < hour) {
        str += Math.floor(delta / minute) + this.$t('time.minutesAgo');
      } else if (Math.floor(delta / hour) == 1) {
        str += this.$t('time.hourAgo');
      } else if (delta < day) {
        str += Math.floor(delta / hour) + this.$t('time.hoursAgo');
      } else if (delta < day * 2) {
        str += this.$t('time.yesterday');
      } else if (delta < day * 7) {
        str += Math.floor(delta / day) + this.$t('time.daysAgo');
      } else if (delta < month) {
        str += Math.floor(delta / week) + this.$t('time.weeksAgo');
      } else if (delta < year) {
        str += Math.floor(delta / month) + this.$t('time.monthsAgo');
      } else {
        str += Math.floor(delta / year) + this.$t('time.yearsAgo');
      }
      return str;
    },
    
    timeFormatter(t) {
      return timeFormatter(t);
    },
  },
  destroyed() {
    this.scroll.removeEventListener("scroll", this.handleScroll);
    clearInterval(this.interval);
  }

}
</script>
